import {
    mapGetters,
    mapActions,
    mapMutations
  } from 'vuex'
  
  import * as salesRevenueManagerStore from '@/store/salesRevenueManager'
  
  export {
    salesRevenueManagerStore
  }
  
  /**
     * Search store.
     *
     * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
     */
  export const createSalesRevenueManagerMixin = (without = []) => {
    const actions = !without.includes('actions') ? mapActions(salesRevenueManagerStore.moduleName, Object.keys(salesRevenueManagerStore.actionTypes)) : {}
    const getters = !without.includes('getters') ? mapGetters(salesRevenueManagerStore.moduleName, Object.keys(salesRevenueManagerStore.getterTypes)) : {}
    const mutations = !without.includes('mutations') ? mapMutations(salesRevenueManagerStore.moduleName, Object.keys(salesRevenueManagerStore.mutationTypes)) : {}
  
    return {
      methods: {
        ...actions,
        ...mutations
      },
      computed: {
        ...getters
      }
    }
  }
  